import { render, staticRenderFns } from "./myApproval.vue?vue&type=template&id=7ec64765&"
import script from "./myApproval.vue?vue&type=script&lang=js&"
export * from "./myApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports